<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="680_auto"
      :visible.sync="modalVisible"
      @confirm="confirm"
      :loading="axiosLoading"
      :confirm-loading="loading"
  >
    <template #header>添加邮箱</template>
    <template #content>

      <mailAuthorization
          ref="mailAuthorization"
          :form="form"
          :marketItem="marketItem"
          @after="after"
          @emailsLoading="axiosLoading = false"
      ></mailAuthorization>

<!--      <el-form-->
<!--          ref="form"-->
<!--          :model="form"-->
<!--          label-width="90px"-->
<!--          :rules="validateRules"-->
<!--      >-->
<!--        <el-form-item-->
<!--            label="方式"-->
<!--        >-->
<!--          <el-radio-group v-model="form.type" @change="changeType">-->
<!--            <el-radio :label="0">添加新邮箱</el-radio>-->
<!--            <el-radio :label="1">已授权的邮箱</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
<!--        <el-form-item-->
<!--                prop="name"-->
<!--                label="用户名"-->
<!--                v-show="form.type === 0"-->
<!--        >-->
<!--          <gj-input width="480px" v-model="form.name" placeholder="请输入用户名"></gj-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item-->
<!--            label="账号"-->
<!--        >-->
<!--          <gj-input width="480px" :value="marketItem.marketName" disabled></gj-input>-->
<!--        </el-form-item>-->

<!--        <el-form-item-->
<!--            label="国家"-->
<!--        >-->
<!--          <gj-input width="480px" :value="getCountry()" disabled></gj-input>-->
<!--          <el-checkbox-group v-model="form.marketIds">-->
<!--            <template v-if="marketItem.items.filter(v => isMeaningless(v.email)).length> 1">-->
<!--              <template v-for="(item, index) in marketItem.items">-->
<!--                <el-checkbox v-if="isMeaningless(item.email)" :key="index" :label="item.id">-->
<!--                  {{countryMap[item.countryCode] ? countryMap[item.countryCode].text : '-'}}-->
<!--                </el-checkbox>-->
<!--              </template>-->
<!--            </template>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->

<!--        <template v-if="form.type === 1">-->
<!--          <el-form-item-->
<!--              prop="selectAccount"-->
<!--              label="邮箱"-->
<!--          >-->
<!--            <gj-select-->
<!--                v-model="form.selectAccount"-->
<!--                width="480px"-->
<!--                :options="accounts"-->
<!--                :clearable="false"-->
<!--            ></gj-select>-->
<!--          </el-form-item>-->
<!--        </template>-->

<!--        <template v-if="form.type === 0">-->
<!--          <el-form-item-->
<!--              prop="account"-->
<!--              label="邮箱账号"-->
<!--          >-->
<!--            <gj-input @input="inputAccount" v-model="form.account" width="480px" placeholder="请输入邮箱账号"></gj-input>-->
<!--          </el-form-item>-->
<!--          <div class="form-item-info" style="margin-top: -10px">-->
<!--            <a href="http://help.gerpgo.com/web/#/26?page_id=638" target="_blank">如何获取或设置亚马逊邮箱账号？</a>-->
<!--          </div>-->
<!--          <el-form-item-->
<!--              prop="authCode"-->
<!--              label="密码/密钥"-->
<!--          >-->
<!--            <gj-input v-model="form.authCode" width="480px" placeholder="请输入密码/密钥" type="password"></gj-input>-->
<!--          </el-form-item>-->
<!--          <div class="form-item-info" style="margin-bottom: 0; margin-top: -10px">1、126，163邮箱需要额外验证，请-->
<!--            <gj-button @click="hrefValidMail" style="padding: 0" type="text">点此链接</gj-button>-->
<!--            进行验证-->
<!--          </div>-->
<!--          <div class="form-item-info">2、查看教程-->
<!--            <a href="http://help.gerpgo.com/web/#/26?" target="_blank">《如何获取邮箱授权码》</a>-->
<!--          </div>-->
<!--          <div style="display: flex">-->
<!--            <el-form-item-->
<!--                prop="imapServer"-->
<!--                label="IMAP服务器"-->
<!--            >-->
<!--              <gj-input v-model="form.imapServer" width="350px" placeholder="请输入IMAP服务器"></gj-input>-->
<!--            </el-form-item>-->
<!--            <gj-checkbox @change="changeSSL" style="margin-left: 10px; padding-top: 6px; margin-right: 10px" v-model="form.imapSsl">SSL</gj-checkbox>-->
<!--            <gj-input width="65px" v-model="form.imapPort"></gj-input>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-form>-->
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, isMeaninglessMixin, modalMixIn, responseMixin, userGuideMixin} from "@/minxins";
  // import {amazonCountryOption} from "@/utils/options";
  // import {isMeaningful, isMeaningless, transformToMap} from "@/utils/common";
  import {bindExistEmail, bindNewEmail, sameSellerEmails} from "@/api/crm";

  import mailAuthorization from "../components/mail-authorization"

  export default {
    name: "mail-authorize-modal",
    mixins: [modalMixIn, formRuleMixin, isMeaninglessMixin, responseMixin, userGuideMixin],
    components:{
      mailAuthorization
    },
    props: {
      marketItem: null,
    },
    created() {
      this.form.marketIds.push(this.marketItem.marketId);
      // sameSellerEmails(this.marketItem.marketId)
      //   .then((data) => {
      //     this.accounts = (data || []).map(v => ({id: v, text: v}));
      //   })
    },
    data() {
      return {
        axiosLoading:true,
        loading: false,
        form: {
          name: '',
          type: 1,
          account: null,
          authCode: null,
          marketIds: [],
          imapServer: 'imap.qq.com',
          imapPort: '993',
          imapSsl: true,
          selectAccount: null,
        },
      }
    },
    methods: {
      after(){
        this.$emit('after');
        // 用户引导模式的下一步
        if(this.userGuideState) {
          this.$emit('userGuide')
        }
      },
      confirm() {
        this.$refs.mailAuthorization.confirm();
        // if (this.$gjFormValidate()) {
        //   this.loading = true;
        //   if (this.form.type === 0) {
        //     bindNewEmail(this.form)
        //         .then((res) => {
        //           this.$gjResponseHandle(res, () => {
        //             this.$gjMessage.success('操作成功');
        //             this.$emit('after');
        //           })
        //         }).complete(() => this.loading = false)
        //   } else {
        //     bindExistEmail({
        //       account: this.form.selectAccount,
        //       marketIds: this.form.marketIds,
        //     })
        //         .then((res) => {
        //           this.$gjResponseHandle(res, () => {
        //             this.$gjMessage.success('操作成功');
        //             this.$emit('after');
        //           })
        //         }).complete(() => this.loading = false)
        //   }
        // }
      },
      // changeType() {
      //   this.$nextTick(() => {
      //     this.$refs.form.clearValidate();
      //   })
      // },
      // getCountry() {
      //   if (this.marketItem.region === 'eu') {
      //     return '欧洲';
      //   } else if (this.marketItem.region === 'na') {
      //     return '北美洲';
      //   } else {
      //     return this.countryMap[this.marketItem.countryCode].text;
      //   }
      // },
      // changeSSL(event) {
      //   this.form.imapPort = event ? '993' : '110';
      // },
      // hrefValidMail() {
      //   if (isMeaningful(this.form.account)) {
      //     window.open(`http://config.mail.163.com/settings/imap/login.jsp?uid=${this.form.account}`,"_blank");
      //   } else {
      //     this.$gjMessage.warning('请先输入邮箱账号')
      //   }
      // },
      // inputAccount() {
      //   if (this.form.account.indexOf('@')) {
      //     if (isMeaningless(this.form.imapPort)) {
      //       this.form.imapPort = '110';
      //     }
      //     const postfix = this.form.account.split('@')[1];
      //     if (postfix === 'qq.com') {
      //       this.form.imapServer = 'imap.qq.com';
      //       this.form.imapPort = '993';
      //       this.form.imapSsl = true;
      //     } else if (postfix === '126.com') {
      //       this.form.imapServer = 'imap.126.com';
      //     } else if (postfix === '163.com') {
      //       this.form.imapServer = 'imap.163.com';
      //     } else if (postfix === 'sina.com') {
      //       this.form.imapServer = 'imap.sina.com';
      //     } else if (postfix === 'aliyun.com') {
      //       this.form.imapServer = 'imap.aliyun.com';
      //     } else if (postfix === 'outlook.com' || postfix === 'hotmail.com') {
      //       this.form.imapServer = 'imap-mail.outlook.com';
      //       this.form.imapPort = '993';
      //       this.form.imapSsl = true;
      //     } else if (postfix === 'gmail.com') {
      //       this.form.imapServer = 'imap.gmail.com';
      //       this.form.imapPort = '993';
      //       this.form.imapSsl = true;
      //     } else if (postfix === '189.cn') {
      //       this.form.imapServer = 'imap.189.cn';
      //       this.form.imapPort = '993';
      //       this.form.imapSsl = true;
      //     }
      //     if (isMeaningful(this.form.imapServer)) {
      //       this.$refs.form.clearValidate('imapServer');
      //     }
      //   }
      // }
    }
  }
</script>

<style scoped>
  .form-item-info {
    height: 20px;
    padding-left: 120px;
    font-size: 12px;
    margin-bottom: 15px;
  }

  /deep/ .gj-modal--custom .el-dialog {
    height: auto !important;
    width: 600px !important;
  }

  /deep/ .el-checkbox__label {
    font-size: 12px;
  }
  /deep/ .el-form-item__error {
    position: initial;
  }
  /deep/ a {
    color: #1F6EEF;
    text-decoration: none;
  }
</style>
